import {
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';
import { citymapApiRef, CitymapClient } from './api';

export const citymapPlugin = createPlugin({
  id: 'citymap',
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: citymapApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new CitymapClient({ discoveryApi, fetchApi }),
    }),
  ],
});

export const CitymapPage = citymapPlugin.provide(
  createRoutableExtension({
    name: 'CitymapPage',
    component: () =>
      import('./components/CitymapPage').then(m => m.CitymapPage),
    mountPoint: rootRouteRef,
  }),
);
